import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./IdleLogout.css";

const IDLE_LIMIT = 15 * 60 * 1000;     // 15 minutes
const WARNING_TIME = 60 * 1000;        // show modal 60s before logout

export default function IdleLogout() {
  const navigate = useNavigate();

  const idleTimer = useRef(null);
  const warningTimer = useRef(null);

  const [showWarning, setShowWarning] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(60);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("firstName");
    navigate("/login", { replace: true });
  }, [navigate]);

  const resetTimers = useCallback(() => {
    clearTimeout(idleTimer.current);
    clearTimeout(warningTimer.current);

    setShowWarning(false);
    setSecondsLeft(60);

    // Warning modal timer
    warningTimer.current = setTimeout(() => {
      setShowWarning(true);

      let countdown = 60;
      const interval = setInterval(() => {
        countdown -= 1;
        setSecondsLeft(countdown);

        if (countdown <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    }, IDLE_LIMIT - WARNING_TIME);

    // Final logout timer
    idleTimer.current = setTimeout(logout, IDLE_LIMIT);
  }, [logout]);

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) =>
      window.addEventListener(event, resetTimers)
    );

    resetTimers();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimers)
      );
      clearTimeout(idleTimer.current);
      clearTimeout(warningTimer.current);
    };
  }, [resetTimers]);

  if (!showWarning) return null;

  return (
    <div className="idle-modal-backdrop">
      <div className="idle-modal">
        <h2>Session Expiring</h2>
        <p>
          You will be logged out due to inactivity in{" "}
          <strong>{secondsLeft}</strong> seconds.
        </p>
        <button onClick={resetTimers}>Stay Logged In</button>
      </div>
    </div>
  );
}